const CLASS_HIDE = 'hide';
const CLASS_GRADIENT = 'gradient';
const CLASS_SHOW = 'show';
const { MAIN_EASING } = require('util/consts');
const {
	default: { slowDelay },
} = require('util/sass-variables');
const {
	getNumber,
	awaitEventOn,
	trackSeeMore,
	trackGtm4,
} = require('util/functions');
const asyncImport = require('util/asyncImport').default;

const scrollDuration = getNumber(slowDelay) * 1000;

module.exports = {
	async init() {
		this.initElements();
		await asyncImport(this, 'anime');
		this.initEvents();
	},

	initElements() {
		this.container = this.root.querySelector('.show-more--container');
		this.content = this.container.querySelector('.show-more--content');
		this.intro = this.root.querySelector('.show-more--intro');
		this.button = this.root.querySelector('.show-more--button');
		this.lessButton = this.root.querySelector('.show-more--less-button');
	},

	initEvents() {
		this.button.addEventListener('click', this.open.bind(this));
		this.lessButton.addEventListener('click', this.close.bind(this));
	},
	getTitle() {
		return (
			this.title ||
			(() => {
				const { textContent } = this.intro;
				const words = textContent.split(' ');
				const mustBeCropped = words.length > 5;
				this.title =
					(mustBeCropped ? words.slice(0, 5) : words).join(' ') +
					(mustBeCropped ? ' ...' : '');
				return this.title;
			})()
		);
	},
	open() {
		this.trackToggling(true);
		this.button.classList.add(CLASS_HIDE);
		this.intro.classList.remove(CLASS_GRADIENT);
		const height = this.content.offsetHeight;
		this.changeContainerHeight(height);
		this.lessButton.classList.add(CLASS_SHOW);
		trackGtm4({
			event: 'GA4_event_c_content_interaction',
			widget_name: 'V3-Show-more',
			widget_title: this.getTitle(),
			link_text: this.button.innerHTML,
			interaction_type: 'show more',
		});
	},
	async close() {
		this.trackToggling(false);
		this.lessButton.classList.remove(CLASS_SHOW);
		this.button.classList.remove(CLASS_HIDE);
		this.changeContainerHeight(0);
		this.intro.classList.add(CLASS_GRADIENT);
		await awaitEventOn(this.container, 'transitionend');
		this.scrollUp();
		trackGtm4({
			event: 'GA4_event_c_content_interaction',
			widget_name: 'V3-Show-more',
			widget_title: this.getTitle(),
			link_text: this.lessButton.innerHTML.trim(),
			interaction_type: 'show less',
		});
	},
	trackToggling(isUnfolded) {
		trackSeeMore(this.getTitle(), 'show-more-widget', isUnfolded);
	},
	changeContainerHeight(height) {
		const initialHeight = getNumber(this.container.style.height);
		const distance = Math.abs(height - initialHeight);
		const duration = (scrollDuration * distance) / 1000;
		this.container.style.height = height + 'px';
		this.container.style.transition = `${duration / 1000}s height ease-in-out`;
	},

	scrollUp() {
		const showMoreButtonTop = this.button.getBoundingClientRect().top;
		if (showMoreButtonTop < 0) {
			const buttonTop = showMoreButtonTop + window.pageYOffset;
			const targetScroll = buttonTop - 200;
			const distance = Math.abs(targetScroll - window.pageXOffset);
			this.animation = this.anime({
				targets: document.scrollingElement,
				scrollTop: targetScroll,
				easing: MAIN_EASING,
				duration: (scrollDuration * distance) / 10000,
			});
		}
	},
};
